import { SyncModalStyle } from './SyncModal.style';

function RestoreModal({ isModalVisible, setIsModalVisible }) {
  const handleOk = () => {
    setIsModalVisible(false);
  };
  const handleCancel = () => {
    setIsModalVisible(handleCancel);
  };
  return (
    <SyncModalStyle
      visible={isModalVisible}
      onOk={handleOk}
      footer={null}
      onCancel={handleCancel}
      className="syncModal"
    >
      <>
        <div className="addToPlaylistHead" style={{ border: 'none', padding: 0 }}>
          <h1 className="heading headingCenter">Restoring your songs</h1>
        </div>
        <div className="loadingDiv">
          <div className="loadingCircle"></div>
        </div>
      </>
    </SyncModalStyle>
  );
}

export default RestoreModal;
